import { IoCheckmarkCircle, IoCloseCircleSharp } from "react-icons/io5";
import defalutImg from "../../../assets/images/default_profile_img.png";
import { userRoles } from "../../../util/UserRoles";
import { ClubAPI } from "../../../api/ClubAPI";
import { Privileges } from "../../../util/PrivilegeConstants";


const RequestItem = ({ request, clubId, setIsLoading, setRefresh, privileges }) => {
    const handleJoinRequestAction = async (requestStatus) => {
        try {
            setIsLoading(true);
            await ClubAPI.joinRequestAction({
                userId: request?.userId,
                clubId: clubId,
                requestStatus: requestStatus
            });
            setRefresh(true);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }
    return (
        <div className="sm_requests_item_con">
            <div className="sm_req_user_img_name">
                <img loading="lazy" src={request?.userProfileImage ? `${import.meta.env.VITE_APP_BASE_URL}/user/user-profile-img/${request.userProfileImage}` : defalutImg} alt="" />
                <p className="sm_req_user_name">{request?.userFirstName + " " + request?.userLastName}</p>
            </div>
            {request.userRole === userRoles.user && <p className="sm_req_user_type">Player</p>}
            {request.userRole === userRoles.guardian && <p className="sm_req_user_type">Guardian</p>}
            <p className="sm_req_user_email">koushikj389@gmail.com</p>
            {privileges?.MANAGE_CLUB_JOIN_REQUEST?.includes(Privileges.MODIFY) &&
             <div className="sm_req_action_btn_con">
                <button
                    onClick={() => handleJoinRequestAction('APPROVED')}
                    className="sm_req_action_accept_btn"><IoCheckmarkCircle />Accept</button>
                <button
                    onClick={() => handleJoinRequestAction('REJECTED')} className="sm_req_action_reject_btn"><IoCloseCircleSharp />Reject</button>
            </div>}
        </div>
    )
}
export default RequestItem;